import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MatFormFieldControl } from '@angular/material/form-field'
import { eq } from 'lodash'
import { map, startWith, Subject, takeUntil } from 'rxjs'

import { CustomMaterialInputControlComponent } from '../../../custom-field'

@Component({
  selector: 'mmx-code-modifiers-form',
  templateUrl: './code-modifiers-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: CodeModifiersFormComponent,
    },
  ],
  standalone: false,
})
export class CodeModifiersFormComponent
  extends CustomMaterialInputControlComponent<Record<string, string[]>>
  implements OnInit, OnChanges, OnDestroy {
  @Input() public codes: string[]

  public formGroup = new FormGroup({})

  public controlKeys$ = this.formGroup.valueChanges.pipe(
    startWith({}),
    map(() => Object.keys(this.formGroup.controls)),
  )

  private onDestroy$ = new Subject<void>()

  public ngOnInit() {
    this.formGroup.valueChanges
      .pipe(
        takeUntil(this.onDestroy$),
      )
      .subscribe((value) => {
        this.value = Object.keys(value).reduce((acc, key) => {
          const modifiers = value[key]
          if (!modifiers?.length) {
            return acc
          }

          return {
            ...acc,
            [key]: modifiers,
          }
        }, {})
      })
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (!changes.codes || eq(changes.codes.currentValue, changes.codes.previousValue)) {
      return
    }

    Object.keys(this.formGroup.controls).forEach((key) => {
      if (!this.codes.includes(key)) {
        this.formGroup.removeControl(key)
      }
    })

    this.codes.forEach((code) => {
      if (!this.formGroup.get(code)) {
        this.formGroup.addControl(code, new FormControl(this.value?.[code] ?? []))
      }
    })

    this.formGroup.updateValueAndValidity()
  }

  public writeValue(value: Record<string, string[]>) {
    this.value = value
    this.formGroup.patchValue(value)
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
